import React__default from 'react';

function ItemSummaryCardShimmer() {
    return (React__default.createElement("div", { className: "item-summary-card--shimmer" },
        React__default.createElement("div", { className: "item-summary-card__item--shimmer" },
            React__default.createElement("div", { className: "item-summary-card__name--shimmer" }),
            React__default.createElement("div", { className: "item-summary-card__options--shimmer" })),
        React__default.createElement("div", { className: "item-summary-card__quantity--shimmer" })));
}

export { ItemSummaryCardShimmer as default };
//# sourceMappingURL=index.shimmer.js.map
